export class ServizioSearch {

  idImmobile: number;
	idTipologiaServizio: number;
	idProfilo: number;
	stato: string[];
	numeroPagina: number;
	numeroElementi: number;
	mese: number;
	anno: number;
	soloInScadenza: boolean;
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/servizio-search.ts